/* modal */
export const openSotaModal = (modalType, modalProps, effect = "slide") => {
  return { type: "OPEN_MODAL", modalType, modalProps, effect };
};

export const closeSotaModal = () => {
  return { type: "CLOSE_MODAL" };
};
